import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { ExerciseCardComponent } from '../exercise-card/exercise-card.component';
import {
  ExaminationSession,
  Exercise,
  ExerciseWithResults,
} from '@lyceo/lyceo-pupil-app/practise/util-models';
import { ExerciseResult } from '@lyceo/shared/util-models';

@Component({
  selector: 'lyceo-paragraph-exercise',
  imports: [ExerciseCardComponent],
  templateUrl: './paragraph-exercise.component.html',
  styleUrls: ['./paragraph-exercise.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParagraphExerciseComponent {
  public readonly exercises: InputSignal<ExerciseWithResults[]> =
    input.required<ExerciseWithResults[]>();
  public readonly loading: InputSignal<boolean> = input<boolean>(false);
  public readonly exerciseClicked: OutputEmitterRef<Exercise> =
    output<Exercise>();
  public readonly viewResultsClicked: OutputEmitterRef<
    ExerciseResult<ExaminationSession>
  > = output<ExerciseResult<ExaminationSession>>();
}
